/* src/app/front-layout/free-assessment/free-assessment.component.css */
.fa-page {
  --fa-p: #0B4F6C;
  --fa-s: #01BAEF;
  --fa-g: #F5A623;
  --fa-d: #06253A;
  --fa-li: #EBF7FB;
  --fa-bo: #CBECF4;
  --fa-mu: #6B8FA0;
  --fa-bg: #F4F8FA;
  --fa-surf: #FFFFFF;
  --fa-tx: #1E3A4A;
  --fa-tl: #4A6477;
  --fa-free: #F5A623;
  --fa-free-li: #FEF3DC;
  --fa-onl: #0B4F6C;
  --fa-onl-li: #EBF7FB;
  font-family:
    "Nunito",
    "Segoe UI",
    sans-serif;
  color: var(--fa-tx);
  background: var(--fa-bg);
  box-sizing: border-box;
  overflow-x: hidden;
}
.fa-page * {
  box-sizing: border-box;
}
.fa-page h1,
.fa-page h2,
.fa-page h3,
.fa-page h4,
.fa-page p {
  margin: 0;
  padding: 0;
}
.fa-container {
  max-width: 1240px !important;
  width: 100% !important;
  margin-left: auto !important;
  margin-right: auto !important;
  padding-left: 48px !important;
  padding-right: 48px !important;
  float: none !important;
}
.fa-eyebrow {
  font-size: 11px !important;
  font-weight: 800 !important;
  letter-spacing: .14em;
  text-transform: uppercase;
  color: var(--fa-s) !important;
  display: flex !important;
  align-items: center;
  gap: 8px;
}
.fa-eyebrow::before,
.fa-eyebrow::after {
  content: "";
  height: 2px;
  width: 18px;
  background: var(--fa-s);
  border-radius: 2px;
  display: block;
  flex-shrink: 0;
}
.fa-eyebrow--light {
  color: rgba(255, 255, 255, .6) !important;
}
.fa-eyebrow--light::before,
.fa-eyebrow--light::after {
  background: rgba(255, 255, 255, .35);
}
.fa-section-title {
  font-size: clamp(23px, 3vw, 36px) !important;
  font-weight: 900 !important;
  color: var(--fa-d) !important;
  line-height: 1.2 !important;
  letter-spacing: -.4px;
}
.fa-section-title span {
  color: var(--fa-s) !important;
}
.fa-section-title--light {
  color: #fff !important;
}
.fa-section-title--light span {
  color: var(--fa-g) !important;
}
.fa-section-sub {
  font-size: 15px !important;
  color: var(--fa-tl) !important;
  line-height: 1.7 !important;
  margin-top: 10px !important;
  max-width: 540px;
}
.fa-section-hd {
  text-align: center !important;
  margin-bottom: 44px !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  gap: 8px;
}
.fa-btn-primary {
  display: inline-flex !important;
  align-items: center;
  gap: 8px;
  background: var(--fa-g) !important;
  color: var(--fa-d) !important;
  border: none !important;
  border-radius: 100px !important;
  padding: 13px 28px !important;
  font-size: 15px !important;
  font-weight: 800 !important;
  cursor: pointer;
  font-family: inherit;
  transition: transform .2s, box-shadow .2s;
}
.fa-btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(245, 166, 35, .4) !important;
}
.fa-btn-ghost {
  display: inline-flex !important;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, .1) !important;
  color: rgba(255, 255, 255, .9) !important;
  border: 1.5px solid rgba(255, 255, 255, .25) !important;
  border-radius: 100px !important;
  padding: 11px 24px !important;
  font-size: 15px !important;
  font-weight: 700 !important;
  cursor: pointer;
  font-family: inherit;
  transition: background .2s;
}
.fa-btn-ghost:hover {
  background: rgba(255, 255, 255, .18) !important;
}
.fa-hero {
  background:
    linear-gradient(
      135deg,
      #04111a 0%,
      var(--fa-d) 55%,
      #0a6070 100%) !important;
  padding: 80px 0 64px !important;
  position: relative;
  overflow: hidden;
  width: 100% !important;
}
.fa-hero-blob {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
}
.fa-hero-blob--1 {
  width: 600px;
  height: 600px;
  background:
    radial-gradient(
      circle,
      rgba(1, 186, 239, .07) 0%,
      transparent 70%);
  top: -200px;
  right: -150px;
}
.fa-hero-blob--2 {
  width: 300px;
  height: 300px;
  background:
    radial-gradient(
      circle,
      rgba(245, 166, 35, .06) 0%,
      transparent 70%);
  bottom: -100px;
  left: -60px;
}
.fa-hero-inner {
  display: grid !important;
  grid-template-columns: 1fr 420px !important;
  gap: 52px !important;
  align-items: center !important;
  position: relative;
  z-index: 1;
}
.fa-hero-badge {
  display: inline-flex !important;
  align-items: center;
  gap: 8px;
  background: rgba(245, 166, 35, .15);
  border: 1px solid rgba(245, 166, 35, .3);
  border-radius: 100px;
  padding: 7px 16px;
  font-size: 12px !important;
  font-weight: 700 !important;
  color: var(--fa-g) !important;
  letter-spacing: .04em;
  margin-bottom: 18px;
}
.fa-badge-pulse {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--fa-g);
  animation: fa-pulse 2s infinite;
  flex-shrink: 0;
}
@keyframes fa-pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.5);
    opacity: .5;
  }
}
.fa-hero-title {
  font-size: clamp(30px, 4.5vw, 52px) !important;
  font-weight: 900 !important;
  color: #fff !important;
  line-height: 1.1 !important;
  letter-spacing: -1px;
  margin-bottom: 14px !important;
}
.fa-hero-title em {
  font-style: normal;
  color: var(--fa-s) !important;
}
.fa-hero-sub {
  font-size: 15px !important;
  color: rgba(255, 255, 255, .62) !important;
  line-height: 1.7 !important;
  margin-bottom: 24px !important;
}
.fa-hero-actions {
  display: flex !important;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 28px;
}
.fa-hero-stats {
  display: flex !important;
  align-items: center;
  gap: 0;
  flex-wrap: wrap;
  background: rgba(255, 255, 255, .06);
  border: 1px solid rgba(255, 255, 255, .1);
  border-radius: 14px;
  padding: 14px 20px !important;
}
.fa-hstat {
  text-align: center;
  padding: 0 18px !important;
}
.fa-hstat strong {
  display: block;
  font-size: 17px !important;
  font-weight: 900 !important;
  color: var(--fa-g) !important;
  line-height: 1;
  margin-bottom: 3px;
}
.fa-hstat span {
  font-size: 10px !important;
  color: rgba(255, 255, 255, .45) !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: .06em;
}
.fa-hstat-div {
  width: 1px;
  height: 32px;
  background: rgba(255, 255, 255, .1);
  flex-shrink: 0;
}
.fa-hero-card {
  background: rgba(255, 255, 255, .06);
  border: 1.5px solid rgba(255, 255, 255, .12);
  border-radius: 20px;
  padding: 28px !important;
}
.fa-hero-card-title {
  display: flex !important;
  align-items: center;
  gap: 7px;
  font-size: 13px !important;
  font-weight: 800 !important;
  color: var(--fa-g) !important;
  letter-spacing: .06em;
  text-transform: uppercase;
  margin-bottom: 22px;
}
.fa-incl-list {
  display: flex !important;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
}
.fa-incl-item {
  display: flex !important;
  align-items: flex-start;
  gap: 12px;
}
.fa-incl-ico {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  flex-shrink: 0;
  display: flex !important;
  align-items: center;
  justify-content: center;
}
.fa-incl-ico--green {
  background: rgba(245, 166, 35, .2);
  color: var(--fa-g);
}
.fa-incl-ico--blue {
  background: rgba(1, 186, 239, .2);
  color: var(--fa-s);
}
.fa-incl-ico--gold {
  background: rgba(245, 166, 35, .2);
  color: var(--fa-g);
}
.fa-incl-ico--purple {
  background: rgba(11, 79, 108, .25);
  color: var(--fa-s);
}
.fa-incl-label {
  font-size: 14px !important;
  font-weight: 800 !important;
  color: #fff !important;
  margin-bottom: 2px;
}
.fa-incl-sub {
  font-size: 12px !important;
  color: rgba(255, 255, 255, .5) !important;
  font-weight: 600 !important;
}
.fa-hero-card-cta {
  width: 100% !important;
  background: var(--fa-g) !important;
  color: var(--fa-d) !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 13px 20px !important;
  font-size: 15px !important;
  font-weight: 800 !important;
  cursor: pointer;
  font-family: inherit;
  transition: transform .2s, box-shadow .2s;
}
.fa-hero-card-cta:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 22px rgba(245, 166, 35, .4) !important;
}
.fa-trust {
  background: var(--fa-surf) !important;
  border-bottom: 1px solid var(--fa-bo);
  width: 100% !important;
}
.fa-trust-inner {
  display: flex !important;
  align-items: center;
  justify-content: center;
  gap: 0;
  flex-wrap: wrap;
  padding: 16px 0 !important;
}
.fa-trust-item {
  display: flex !important;
  align-items: center;
  gap: 8px;
  font-size: 13px !important;
  font-weight: 700 !important;
  color: var(--fa-tx) !important;
  padding: 0 24px !important;
}
.fa-trust-item svg {
  color: var(--fa-p);
  flex-shrink: 0;
}
.fa-trust-div {
  width: 1px;
  height: 20px;
  background: var(--fa-bo);
  flex-shrink: 0;
}
.fa-how {
  padding: 72px 0 !important;
  background: var(--fa-surf) !important;
  width: 100% !important;
}
.fa-steps {
  display: grid !important;
  grid-template-columns: repeat(4, 1fr) !important;
  gap: 0 !important;
  position: relative;
}
.fa-step {
  display: flex !important;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 0 16px !important;
  position: relative;
}
.fa-step-connector {
  position: absolute;
  top: 50px;
  right: -1px;
  width: 50%;
  height: 2px;
  background:
    linear-gradient(
      90deg,
      var(--fa-bo),
      var(--fa-s));
  z-index: 0;
}
.fa-step--last .fa-step-connector {
  display: none;
}
.fa-step-num {
  font-size: 11px !important;
  font-weight: 900 !important;
  color: var(--fa-s) !important;
  letter-spacing: .1em;
  text-transform: uppercase;
  margin-bottom: 12px;
}
.fa-step-num--gold {
  color: var(--fa-g) !important;
}
.fa-step-ico {
  width: 64px;
  height: 64px;
  border-radius: 18px;
  background: var(--fa-li);
  border: 2px solid var(--fa-bo);
  display: flex !important;
  align-items: center;
  justify-content: center;
  color: var(--fa-p);
  margin-bottom: 16px;
  flex-shrink: 0;
  position: relative;
  z-index: 1;
  transition:
    background .2s,
    border-color .2s,
    color .2s;
}
.fa-step:hover .fa-step-ico {
  background: var(--fa-p);
  border-color: var(--fa-p);
  color: #fff;
}
.fa-step-ico--gold {
  background: rgba(245, 166, 35, .12) !important;
  border-color: rgba(245, 166, 35, .3) !important;
  color: var(--fa-g) !important;
}
.fa-step--last:hover .fa-step-ico {
  background: var(--fa-g) !important;
  border-color: var(--fa-g) !important;
  color: var(--fa-d) !important;
}
.fa-step-title {
  font-size: 15px !important;
  font-weight: 800 !important;
  color: var(--fa-d) !important;
  margin-bottom: 8px !important;
}
.fa-step-text {
  font-size: 13px !important;
  color: var(--fa-tl) !important;
  line-height: 1.65 !important;
}
.fa-details {
  padding: 72px 0 !important;
  background: var(--fa-bg) !important;
  width: 100% !important;
}
.fa-details-grid {
  display: grid !important;
  grid-template-columns: 1fr 1fr !important;
  gap: 24px !important;
}
.fa-detail-card {
  background: var(--fa-surf) !important;
  border: 1.5px solid var(--fa-bo) !important;
  border-radius: 20px !important;
  padding: 32px !important;
  position: relative;
  overflow: hidden;
  transition: box-shadow .2s, transform .2s;
}
.fa-detail-card:hover {
  box-shadow: 0 12px 40px rgba(11, 79, 108, .1) !important;
  transform: translateY(-3px);
}
.fa-detail-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
}
.fa-detail-card--rar::before {
  background:
    linear-gradient(
      90deg,
      var(--fa-p),
      var(--fa-s));
}
.fa-detail-card--ptm::before {
  background:
    linear-gradient(
      90deg,
      var(--fa-g),
      var(--fa-s));
}
.fa-detail-card-header {
  display: flex !important;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
}
.fa-detail-icon {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background:
    linear-gradient(
      135deg,
      var(--fa-p),
      var(--fa-s));
  display: flex !important;
  align-items: center;
  justify-content: center;
  color: #fff;
  flex-shrink: 0;
  box-shadow: 0 6px 18px rgba(11, 79, 108, .2);
}
.fa-detail-icon--gold {
  background:
    linear-gradient(
      135deg,
      var(--fa-g),
      var(--fa-s)) !important;
}
.fa-detail-tag {
  font-size: 10px !important;
  font-weight: 800 !important;
  text-transform: uppercase;
  letter-spacing: .1em;
  color: var(--fa-s) !important;
  margin-bottom: 3px;
}
.fa-detail-tag--gold {
  color: var(--fa-g) !important;
}
.fa-detail-title {
  font-size: 22px !important;
  font-weight: 900 !important;
  color: var(--fa-d) !important;
  line-height: 1.2 !important;
}
.fa-detail-intro {
  font-size: 14px !important;
  color: var(--fa-tl) !important;
  line-height: 1.7 !important;
  margin-bottom: 20px !important;
}
.fa-detail-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex !important;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 24px !important;
}
.fa-detail-list li {
  display: flex !important;
  align-items: flex-start;
  gap: 10px;
  font-size: 13px !important;
  color: var(--fa-tx) !important;
  line-height: 1.6 !important;
}
.fa-detail-list li svg {
  color: var(--fa-p);
  flex-shrink: 0;
  margin-top: 3px;
}
.fa-detail-list li strong {
  color: var(--fa-d);
}
.fa-detail-footer {
  display: flex !important;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.fa-detail-badge {
  display: inline-flex !important;
  align-items: center;
  background: var(--fa-li) !important;
  border: 1px solid var(--fa-bo) !important;
  border-radius: 100px;
  padding: 5px 14px !important;
  font-size: 11px !important;
  font-weight: 800 !important;
  color: var(--fa-p) !important;
}
.fa-detail-badge--free {
  background: var(--fa-free-li) !important;
  border-color: rgba(245, 166, 35, .35) !important;
  color: var(--fa-d) !important;
}
.fa-why {
  padding: 72px 0 !important;
  background: var(--fa-surf) !important;
  width: 100% !important;
}
.fa-why-inner {
  display: grid !important;
  grid-template-columns: 1fr 400px !important;
  gap: 64px !important;
  align-items: center !important;
}
.fa-why-text {
  font-size: 15px !important;
  color: var(--fa-tl) !important;
  line-height: 1.75 !important;
  margin-top: 16px !important;
}
.fa-why-promise {
  display: grid !important;
  grid-template-columns: 1fr 1fr !important;
  gap: 10px !important;
  margin-top: 28px !important;
}
.fa-promise-item {
  display: flex !important;
  align-items: center;
  gap: 10px;
  background: var(--fa-bg) !important;
  border: 1.5px solid var(--fa-bo) !important;
  border-radius: 12px !important;
  padding: 12px 14px !important;
  font-size: 13px !important;
  font-weight: 700 !important;
  color: var(--fa-tx) !important;
}
.fa-promise-ico {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: var(--fa-free-li);
  display: flex !important;
  align-items: center;
  justify-content: center;
  color: var(--fa-p);
  flex-shrink: 0;
}
.fa-why-card {
  background:
    linear-gradient(
      135deg,
      var(--fa-d) 0%,
      var(--fa-p) 100%) !important;
  border-radius: 20px !important;
  padding: 32px !important;
  box-shadow: 0 20px 56px rgba(6, 37, 58, .3);
}
.fa-why-card-top {
  display: flex !important;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
  color: var(--fa-g);
}
.fa-why-card-label {
  font-size: 11px !important;
  font-weight: 700 !important;
  color: rgba(255, 255, 255, .45) !important;
  text-transform: uppercase;
  letter-spacing: .07em;
  margin-bottom: 2px;
}
.fa-why-card-num {
  font-size: 32px !important;
  font-weight: 900 !important;
  color: #fff !important;
  line-height: 1;
}
.fa-why-card-sub {
  font-size: 12px !important;
  color: rgba(255, 255, 255, .5) !important;
  font-weight: 600 !important;
  margin-top: 2px;
}
.fa-why-divider {
  height: 1px;
  background: rgba(255, 255, 255, .1);
  margin: 0 0 20px;
}
.fa-why-quote {
  font-size: 13px !important;
  color: rgba(255, 255, 255, .75) !important;
  line-height: 1.75 !important;
  font-style: italic;
  margin: 0 0 12px !important;
}
.fa-why-quote-name {
  font-size: 13px !important;
  font-weight: 800 !important;
  color: var(--fa-g) !important;
  display: flex;
  align-items: center;
  gap: 8px;
}
.fa-why-quote-name::before {
  content: "";
  width: 20px;
  height: 2px;
  background: var(--fa-g);
  border-radius: 2px;
  display: block;
  flex-shrink: 0;
}
.fa-list-heading {
  background: var(--fa-bg);
  padding: 56px 0 0 !important;
  width: 100% !important;
}
.fa-filterbar {
  position: sticky !important;
  top: 0;
  z-index: 200;
  background: var(--fa-d) !important;
  border-bottom: 2px solid var(--fa-g);
  box-shadow: 0 4px 24px rgba(0, 0, 0, .25);
  width: 100% !important;
}
.fa-filterbar-main {
  padding: 14px 0 !important;
}
.fa-filters-row {
  display: flex !important;
  align-items: flex-end;
  gap: 10px;
  flex-wrap: wrap;
}
.fa-fg {
  display: flex !important;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
}
.fa-fg--search {
  flex: 2;
  min-width: 200px;
}
.fa-flabel {
  display: flex !important;
  align-items: center;
  gap: 5px;
  font-size: 10px !important;
  font-weight: 800 !important;
  text-transform: uppercase;
  letter-spacing: .1em;
  color: rgba(255, 255, 255, .4) !important;
}
.fa-fselect,
.fa-finput {
  background: rgba(255, 255, 255, .09) !important;
  border: 1.5px solid rgba(255, 255, 255, .13) !important;
  border-radius: 10px !important;
  padding: 10px 13px !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  color: #fff !important;
  font-family: inherit;
  outline: none !important;
  width: 100%;
  transition: border-color .2s, background .2s;
  appearance: none;
  -webkit-appearance: none;
}
.fa-fselect:focus,
.fa-finput:focus {
  border-color: var(--fa-g) !important;
  background: rgba(245, 166, 35, .08) !important;
}
.fa-fselect option {
  background: var(--fa-d);
  color: #fff;
}
.fa-finput::placeholder {
  color: rgba(255, 255, 255, .3);
}
.fa-freset {
  display: inline-flex !important;
  align-items: center;
  gap: 5px;
  background: rgba(192, 57, 43, .15) !important;
  border: 1.5px solid rgba(192, 57, 43, .3) !important;
  border-radius: 10px !important;
  padding: 10px 14px !important;
  font-size: 12px !important;
  font-weight: 700 !important;
  color: #ff8a80 !important;
  cursor: pointer;
  font-family: inherit;
  white-space: nowrap;
  align-self: flex-end;
  transition: background .2s;
}
.fa-freset:hover {
  background: rgba(192, 57, 43, .3) !important;
}
.fa-filterbar-pills {
  border-top: 1px solid rgba(255, 255, 255, .07);
  padding: 8px 0 10px !important;
}
.fa-pills-row {
  display: flex !important;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.fa-pills-label {
  font-size: 11px !important;
  font-weight: 700 !important;
  color: rgba(255, 255, 255, .3) !important;
  white-space: nowrap;
}
.fa-pill {
  display: inline-flex !important;
  align-items: center;
  gap: 5px;
  background: rgba(245, 166, 35, .15) !important;
  border: 1px solid rgba(245, 166, 35, .3) !important;
  border-radius: 100px !important;
  padding: 4px 10px !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  color: var(--fa-g) !important;
}
.fa-pill-x {
  background: none !important;
  border: none !important;
  cursor: pointer;
  color: var(--fa-g) !important;
  font-size: 12px;
  padding: 0;
  opacity: .7;
  line-height: 1;
  font-family: inherit;
  transition: opacity .15s;
}
.fa-pill-x:hover {
  opacity: 1;
}
.fa-count {
  margin-left: auto;
  font-size: 12px !important;
  font-weight: 700 !important;
  color: rgba(255, 255, 255, .35) !important;
}
.fa-sessions {
  padding: 24px 0 72px !important;
  background: var(--fa-bg) !important;
  width: 100% !important;
}
.fa-sortbar {
  display: flex !important;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 8px;
}
.fa-sortbar-count {
  font-size: 13px !important;
  font-weight: 700 !important;
  color: var(--fa-mu) !important;
}
.fa-sortbar-count strong {
  color: var(--fa-p) !important;
}
.fa-sortbar-right {
  display: flex !important;
  align-items: center;
  gap: 6px;
  font-size: 12px !important;
  font-weight: 700 !important;
  color: var(--fa-mu) !important;
}
.fa-scard {
  background: var(--fa-surf) !important;
  border: 1.5px solid var(--fa-bo) !important;
  border-left: 4px solid var(--fa-g) !important;
  border-radius: 16px !important;
  margin-bottom: 10px;
  display: grid !important;
  grid-template-columns: 88px 1fr auto auto !important;
  align-items: stretch;
  overflow: hidden;
  transition:
    border-color .2s,
    box-shadow .2s,
    transform .15s;
}
.fa-scard:hover {
  border-color: var(--fa-g) !important;
  box-shadow: 0 4px 24px rgba(245, 166, 35, .15) !important;
  transform: translateY(-2px);
}
.fa-scard-date {
  background: var(--fa-p);
  display: flex !important;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 14px 8px !important;
  color: #fff;
  text-align: center;
  flex-shrink: 0;
}
.fa-scard-date--range {
  background: var(--fa-g) !important;
}
.fa-scard-date--range .fa-scard-day,
.fa-scard-date--range .fa-scard-mon,
.fa-scard-date--range .fa-scard-yr {
  color: var(--fa-d) !important;
}
.fa-scard-date--tbd {
  background: var(--fa-mu) !important;
  justify-content: center !important;
  gap: 6px;
}
.fa-scard-from {
  font-size: 9px !important;
  font-weight: 700 !important;
  color: rgba(255, 255, 255, .6) !important;
  text-transform: uppercase;
  letter-spacing: .06em;
  display: block;
  margin-bottom: 1px;
}
.fa-scard-day {
  font-size: 28px !important;
  font-weight: 900 !important;
  color: #fff !important;
  line-height: 1;
  display: block;
}
.fa-scard-mon {
  font-size: 13px !important;
  font-weight: 700 !important;
  color: rgba(255, 255, 255, .75) !important;
  text-transform: uppercase;
  letter-spacing: .04em;
  display: block;
  line-height: 1.2;
}
.fa-scard-yr {
  font-size: 11px !important;
  font-weight: 600 !important;
  color: rgba(255, 255, 255, .55) !important;
  display: block;
}
.fa-scard-tbd {
  font-size: 12px !important;
  font-weight: 900 !important;
  color: rgba(255, 255, 255, .7) !important;
  letter-spacing: .08em;
  text-transform: uppercase;
  display: block;
}
.fa-scard-info {
  padding: 14px 18px !important;
  display: flex !important;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  min-width: 0;
}
.fa-scard-top {
  display: flex !important;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.fa-scard-cat {
  font-size: 16px !important;
  font-weight: 800 !important;
  color: var(--fa-p) !important;
  text-decoration: none !important;
  transition: color .2s;
}
.fa-scard-cat:hover {
  color: var(--fa-s) !important;
}
.fa-scard-badge-online {
  display: inline-flex !important;
  align-items: center;
  gap: 5px;
  background: var(--fa-li) !important;
  color: var(--fa-p) !important;
  border-radius: 100px;
  padding: 3px 10px !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  white-space: nowrap;
  border: 1px solid var(--fa-bo) !important;
}
.fa-scard-badge-free {
  display: inline-flex !important;
  align-items: center;
  background: var(--fa-free-li) !important;
  color: var(--fa-d) !important;
  border-radius: 100px;
  padding: 3px 10px !important;
  font-size: 11px !important;
  font-weight: 800 !important;
  white-space: nowrap;
  border: 1px solid rgba(245, 166, 35, .4) !important;
}
.fa-scard-type {
  font-size: 13px !important;
  font-weight: 700 !important;
  color: var(--fa-tx) !important;
  text-decoration: none !important;
}
.fa-scard-name {
  font-size: 12px !important;
  color: var(--fa-mu) !important;
  font-weight: 600 !important;
  text-decoration: none !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.fa-scard-includes {
  display: flex !important;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  margin-top: 3px;
}
.fa-scard-incl-tag {
  display: inline-flex !important;
  align-items: center;
  gap: 4px;
  background: var(--fa-li) !important;
  border: 1px solid var(--fa-bo) !important;
  border-radius: 6px;
  padding: 3px 8px !important;
  font-size: 10px !important;
  font-weight: 700 !important;
  color: var(--fa-p) !important;
}
.fa-scard-incl-tag svg {
  color: var(--fa-s);
}
.fa-scard-price {
  padding: 14px 16px !important;
  display: flex !important;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-left: 1px solid var(--fa-bo);
  min-width: 88px;
}
.fa-price-free {
  font-size: 17px !important;
  font-weight: 900 !important;
  color: var(--fa-d) !important;
  line-height: 1;
}
.fa-price-lbl {
  font-size: 10px !important;
  color: var(--fa-mu) !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: .05em;
  margin-top: 3px;
}
.fa-scard-book {
  padding: 14px 18px !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
  border-left: 1px solid var(--fa-bo);
  background: rgba(245, 166, 35, .06);
}
.fa-book-btn {
  display: flex !important;
  align-items: center;
  gap: 8px;
  background: var(--fa-g) !important;
  color: var(--fa-d) !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 12px 22px !important;
  font-size: 15px !important;
  font-weight: 900 !important;
  cursor: pointer;
  text-decoration: none !important;
  transition:
    transform .2s,
    box-shadow .2s,
    background .2s;
  white-space: nowrap;
  box-shadow: 0 3px 0 rgba(180, 110, 0, .25);
}
.fa-book-btn:hover {
  background: var(--fa-p) !important;
  color: #fff !important;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(245, 166, 35, .3) !important;
}
.fa-empty {
  text-align: center;
  padding: 64px 20px;
  background: var(--fa-surf);
  border: 1.5px solid var(--fa-bo);
  border-radius: 16px;
}
.fa-empty-ico {
  width: 60px;
  height: 60px;
  border-radius: 16px;
  background: var(--fa-li);
  display: flex !important;
  align-items: center;
  justify-content: center;
  color: var(--fa-mu);
  margin: 0 auto 16px;
}
.fa-empty-title {
  font-size: 18px !important;
  font-weight: 800 !important;
  color: var(--fa-d) !important;
  margin-bottom: 8px !important;
}
.fa-empty-sub {
  font-size: 14px !important;
  color: var(--fa-mu) !important;
  margin-bottom: 20px !important;
}
.fa-empty-reset {
  background: none !important;
  border: 1.5px solid var(--fa-bo) !important;
  border-radius: 100px !important;
  padding: 10px 24px !important;
  font-size: 13px !important;
  font-weight: 700 !important;
  color: var(--fa-p) !important;
  cursor: pointer;
  font-family: inherit;
  transition: background .2s, border-color .2s;
}
.fa-empty-reset:hover {
  background: var(--fa-li) !important;
  border-color: var(--fa-s) !important;
}
.fa-testi {
  padding: 72px 0 !important;
  background:
    linear-gradient(
      135deg,
      #06253A 0%,
      var(--fa-p) 60%,
      #0a6070 100%) !important;
  width: 100% !important;
  position: relative;
  overflow: hidden;
}
.fa-testi::before {
  content: "";
  position: absolute;
  width: 500px;
  height: 500px;
  border-radius: 50%;
  background:
    radial-gradient(
      circle,
      rgba(1, 186, 239, .06) 0%,
      transparent 70%);
  top: -200px;
  right: -120px;
  pointer-events: none;
}
.fa-testi-grid {
  display: grid !important;
  grid-template-columns: repeat(3, 1fr) !important;
  gap: 18px !important;
  width: 100% !important;
  position: relative;
  z-index: 1;
}
.fa-tcard {
  background: rgba(255, 255, 255, .07) !important;
  border: 1.5px solid rgba(255, 255, 255, .12) !important;
  border-radius: 18px !important;
  padding: 24px !important;
  position: relative;
  transition: background .2s;
}
.fa-tcard:hover {
  background: rgba(255, 255, 255, .11) !important;
}
.fa-tcard-quote {
  position: absolute;
  top: 10px;
  right: 18px;
  font-size: 56px;
  font-weight: 900;
  color: rgba(255, 255, 255, .08);
  line-height: 1;
}
.fa-tcard-text {
  font-size: 13px !important;
  color: rgba(255, 255, 255, .75) !important;
  line-height: 1.75 !important;
  font-style: italic;
  margin-bottom: 16px !important;
}
.fa-tcard-name {
  font-size: 14px !important;
  font-weight: 800 !important;
  color: var(--fa-g) !important;
  display: flex;
  align-items: center;
  gap: 8px;
}
.fa-tcard-name::before {
  content: "";
  width: 20px;
  height: 2px;
  background: var(--fa-g);
  border-radius: 2px;
  display: block;
  flex-shrink: 0;
}
.fa-faq {
  padding: 72px 0 !important;
  background: var(--fa-bg) !important;
  width: 100% !important;
}
.fa-faq-list {
  max-width: 760px;
  margin: 0 auto !important;
}
.fa-faq-item {
  border: 1.5px solid var(--fa-bo) !important;
  border-radius: 14px !important;
  margin-bottom: 10px;
  overflow: hidden;
  transition: border-color .2s;
}
.fa-faq-item:hover {
  border-color: var(--fa-s) !important;
}
.fa-faq-q {
  display: flex !important;
  align-items: center;
  justify-content: space-between;
  padding: 17px 22px !important;
  cursor: pointer;
  font-size: 15px !important;
  font-weight: 700 !important;
  color: var(--fa-d) !important;
  gap: 12px;
  background: var(--fa-surf);
  border: none !important;
  width: 100%;
  text-align: left;
  font-family: inherit;
}
.fa-faq-q:hover {
  background: var(--fa-li);
}
.fa-faq-chev {
  flex-shrink: 0;
  transition: transform .3s;
  color: var(--fa-p);
}
.fa-faq-item--open .fa-faq-chev {
  transform: rotate(180deg);
  color: var(--fa-s);
}
.fa-faq-a {
  max-height: 0;
  overflow: hidden;
  background: var(--fa-bg);
  border-top: 1px solid var(--fa-bo);
  font-size: 14px !important;
  color: var(--fa-tl) !important;
  line-height: 1.7 !important;
  transition: max-height .35s ease, padding .35s;
  padding: 0 22px !important;
}
.fa-faq-item--open .fa-faq-a {
  max-height: 300px;
  padding: 16px 22px !important;
}
.fa-contact {
  background:
    linear-gradient(
      90deg,
      var(--fa-d) 0%,
      var(--fa-p) 100%) !important;
  padding: 36px 0 !important;
  width: 100% !important;
}
.fa-contact-inner {
  display: flex !important;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
}
.fa-contact-title {
  font-size: 17px !important;
  font-weight: 800 !important;
  color: #fff !important;
}
.fa-contact-links {
  display: flex !important;
  gap: 14px;
  flex-wrap: wrap;
}
.fa-contact-link {
  display: inline-flex !important;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, .1);
  border: 1px solid rgba(255, 255, 255, .18);
  border-radius: 100px;
  padding: 9px 20px;
  font-size: 14px !important;
  font-weight: 700 !important;
  color: rgba(255, 255, 255, .9) !important;
  text-decoration: none !important;
  transition: background .2s;
}
.fa-contact-link:hover {
  background: rgba(255, 255, 255, .2);
  color: var(--fa-g) !important;
}
.fa-page section,
.fa-page .fa-trust,
.fa-page .fa-filterbar,
.fa-page .fa-sessions,
.fa-page .fa-contact {
  width: 100% !important;
  float: none !important;
}
.fa-page .fa-container {
  max-width: 1240px !important;
  width: 100% !important;
  margin-left: auto !important;
  margin-right: auto !important;
  padding-left: 48px !important;
  padding-right: 48px !important;
  float: none !important;
  box-sizing: border-box !important;
}
.fa-page .fa-filterbar .fa-container,
.fa-page .fa-filterbar-pills .fa-container {
  padding-left: 40px !important;
  padding-right: 40px !important;
}
@media (max-width: 1100px) {
  .fa-why-inner {
    grid-template-columns: 1fr !important;
    gap: 36px !important;
  }
  .fa-why-card {
    max-width: 520px;
  }
  .fa-steps {
    grid-template-columns: 1fr 1fr !important;
    gap: 32px !important;
  }
  .fa-step-connector {
    display: none;
  }
}
@media (max-width: 900px) {
  .fa-hero-inner {
    grid-template-columns: 1fr !important;
    gap: 32px !important;
  }
  .fa-details-grid {
    grid-template-columns: 1fr !important;
  }
  .fa-testi-grid {
    grid-template-columns: 1fr 1fr !important;
  }
  .fa-scard {
    grid-template-columns: 68px 1fr auto !important;
  }
  .fa-scard-price {
    display: none !important;
  }
  .fa-trust-inner {
    justify-content: flex-start !important;
  }
  .fa-trust-div {
    display: none !important;
  }
  .fa-trust-item {
    padding: 8px 16px !important;
  }
  .fa-container {
    padding-left: 20px !important;
    padding-right: 20px !important;
  }
  .fa-page .fa-filterbar .fa-container {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }
  .fa-page .fa-filterbar-pills .fa-container {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }
}
@media (max-width: 480px) {
  .fa-container {
    padding-left: 14px !important;
    padding-right: 14px !important;
  }
  .fa-page .fa-filterbar .fa-container {
    padding-left: 12px !important;
    padding-right: 12px !important;
  }
  .fa-page .fa-filterbar-pills .fa-container {
    padding-left: 12px !important;
    padding-right: 12px !important;
  }
  .fa-hero {
    padding: 56px 0 44px !important;
  }
  .fa-hero-title {
    font-size: 28px !important;
  }
  .fa-hero-sub {
    font-size: 13px !important;
  }
  .fa-hero-actions {
    flex-direction: column !important;
    gap: 10px !important;
  }
  .fa-btn-primary,
  .fa-btn-ghost {
    width: 100% !important;
    justify-content: center !important;
  }
  .fa-hero-stats {
    display: grid !important;
    grid-template-columns: 1fr 1fr !important;
    gap: 0 !important;
    padding: 0 !important;
    border-radius: 14px !important;
    overflow: hidden;
  }
  .fa-hstat {
    padding: 12px 10px !important;
  }
  .fa-hstat strong {
    font-size: 14px !important;
  }
  .fa-hstat-div {
    display: none !important;
  }
  .fa-hero-card {
    padding: 20px 16px !important;
  }
  .fa-steps {
    grid-template-columns: 1fr !important;
    gap: 20px !important;
  }
  .fa-step {
    align-items: flex-start !important;
    text-align: left !important;
    flex-direction: row !important;
    gap: 16px !important;
  }
  .fa-step-ico {
    flex-shrink: 0;
    width: 48px !important;
    height: 48px !important;
    margin-bottom: 0 !important;
  }
  .fa-step-num {
    display: none !important;
  }
  .fa-why-promise {
    grid-template-columns: 1fr !important;
  }
  .fa-details-grid {
    grid-template-columns: 1fr !important;
  }
  .fa-detail-card {
    padding: 22px 18px !important;
  }
  .fa-filters-row {
    flex-direction: column !important;
    gap: 8px !important;
  }
  .fa-fg {
    min-width: 100% !important;
  }
  .fa-fselect,
  .fa-finput {
    font-size: 14px !important;
  }
  .fa-freset {
    width: 100% !important;
    justify-content: center !important;
  }
  .fa-scard {
    display: flex !important;
    flex-direction: column !important;
    border-radius: 14px !important;
  }
  .fa-scard-date {
    flex-direction: row !important;
    align-items: center !important;
    justify-content: flex-start !important;
    padding: 10px 14px !important;
    gap: 8px;
  }
  .fa-scard-day {
    font-size: 20px !important;
  }
  .fa-scard-from {
    display: none !important;
  }
  .fa-scard-info {
    padding: 12px 14px 8px !important;
  }
  .fa-scard-cat {
    font-size: 14px !important;
  }
  .fa-scard-name {
    white-space: normal !important;
    overflow: visible !important;
    text-overflow: unset !important;
    line-height: 1.4 !important;
  }
  .fa-scard-price {
    display: none !important;
  }
  .fa-scard-book {
    border-left: none !important;
    border-top: 1px solid var(--fa-bo) !important;
    padding: 10px 14px !important;
  }
  .fa-book-btn {
    width: 100% !important;
    justify-content: center !important;
    font-size: 14px !important;
    border-radius: 10px !important;
    box-shadow: none !important;
  }
  .fa-testi {
    padding: 48px 0 !important;
  }
  .fa-testi-grid {
    grid-template-columns: 1fr !important;
  }
  .fa-faq {
    padding: 48px 0 !important;
  }
  .fa-faq-q {
    padding: 14px 16px !important;
    font-size: 14px !important;
  }
  .fa-section-title {
    font-size: 22px !important;
  }
  .fa-section-hd {
    margin-bottom: 28px !important;
  }
  .fa-contact {
    padding: 28px 0 !important;
  }
  .fa-contact-inner {
    flex-direction: column !important;
    gap: 12px !important;
  }
  .fa-contact-links {
    flex-direction: column !important;
    gap: 8px !important;
    width: 100% !important;
  }
  .fa-contact-link {
    width: 100% !important;
    justify-content: center !important;
  }
}
/*# sourceMappingURL=free-assessment.component.css.map */
